import React, { FC, ReactElement, useEffect, useState } from 'react'
import './style.scss'
import * as d3 from 'd3'

export interface Props {
  /** The actual data to color the map. Each object must contain the property Rank! (e.g. [{bfsId: 261, Rank: "7"},...]) */
  municipalityData: {
    bfsId: number
    GemeindenameFR: string
    Kanton: string
    Rank: number
    Belastung: number
  }[]
  colorPalette: [string, string, string]
  minValue: number
  maxValue: number
  activeMunicipalityId: number
  onSelectionHandler: (selectedId: number) => void
}

export const RankingTable: FC<Props> = ({
  municipalityData,
  colorPalette,
  minValue,
  maxValue,
  onSelectionHandler,
  activeMunicipalityId
}): ReactElement => {
  // useEffect(()=>{},[municipalityData])
  const [showCount, setShowCount] = useState(10)
  const [reversed, setReversed] = useState(false)
  const color = d3
    .scaleLinear<string>()
    .domain([minValue, (minValue + maxValue) / 2, maxValue])
    .range(colorPalette || ['green', 'lightgrey', 'red'])

  return (
    <div className='ui graphic container list' id='ranking'>
      <h4 id='ranking-title'>
        Le {reversed ? 'flop' : 'top'} {showCount}
      </h4>
      <table
        id='ranking-table'
        className='ui small unstackable selectable table'
      >
        <thead>
          <tr>
            <th />
            <th>Commune</th>
            <th>Canton</th>
            <th className='right aligned'>Charge</th>
          </tr>
        </thead>
        <tbody>
          {municipalityData
            .sort((muniA, muniB) =>
              reversed ? muniB.Rank - muniA.Rank : muniA.Rank - muniB.Rank
            )
            .slice(0, showCount)
            .map(municipality => (
              <tr
                key={municipality.bfsId}
                onClick={() => {
                  onSelectionHandler(municipality.bfsId)
                }}
                className={
                  +activeMunicipalityId === municipality.bfsId ? 'selected' : ''
                }
              >
                <td
                  className='center aligned rank'
                  style={{ backgroundColor: color(municipality.Belastung) }}
                >
                  {municipality.Rank}
                </td>
                <td className='municipality-name'>
                  <div className='municipality-name-wrapper'>
                    {municipality.GemeindenameFR}
                  </div>
                </td>
                <td>{municipality.Kanton}</td>
                <td className='right aligned'>
                  {municipality.Belastung.toFixed(2)}%
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <div className='ui vertical small basic labeled icon fluid buttons'>
        <button
          className='ui button'
          onClick={() => setShowCount(showCount + 20)}
        >
          <i className='arrow down icon' /> Afficher 20 communes de plus
        </button>
        <button className='ui button' onClick={() => setReversed(!reversed)}>
          <i
            className={
              'sort content ' +
              (reversed ? 'descending' : 'ascending') +
              ' icon'
            }
          />{' '}
          Inverser le tri
        </button>
      </div>
    </div>
  )
}
